import { FeedbackFilters } from "../components/FeedbackFilters/FeedbackFilters";
import { FeedbackReviewTable } from "../components/FeedbackReviewTable/FeedbackReviewTable";
import { useFeedbackItems, useFeedbackReviewFilters } from "../hooks";
import styles from "./FeedbackReviewScreen.module.css";

export function FeedbackReviewScreen() {
  const filters = useFeedbackReviewFilters();
  const query = useFeedbackItems(filters.filterParams);

  const rows = query.data?.pages.flatMap((page) => page.rows) ?? [];

  return (
    <div className={styles.screen}>
      <header className={styles.header}>
        <h1 className={styles.title}>Eval Steward</h1>
        <p className={styles.subtitle}>
          Review production thumbs-up feedback and promote promising Q&amp;A rows
          to golden-set candidates.
        </p>
      </header>

      <FeedbackFilters filters={filters} />

      {query.isError && !query.isLoading && (
        <div className={styles.errorBanner} data-testid="feedback-list-error">
          Unable to load feedback items.
          <button
            type="button"
            className={styles.retryButton}
            onClick={() => query.refetch()}
          >
            Retry
          </button>
        </div>
      )}

      <FeedbackReviewTable
        rows={rows}
        isLoading={query.isLoading || query.isFetching}
      />

      {query.hasNextPage && (
        <div className={styles.loadMoreContainer}>
          <button
            type="button"
            className={styles.loadMoreButton}
            onClick={() => query.fetchNextPage()}
            disabled={query.isFetchingNextPage}
            data-testid="load-more-button"
          >
            {query.isFetchingNextPage ? "Loading…" : "Load more"}
          </button>
        </div>
      )}
    </div>
  );
}
